export default __webpack_public_path__ + "static/media/eat.205b70ad.gif";